import { createAsyncThunk } from "@reduxjs/toolkit";
import authApi from "../../authApi";
import {
  getResourceAssets,
  getResourceAssetsByIuserId,
  getUserPaymentData,
  saveNewExternalData,
  setContactExternalResource,
  setEditExternalResource,
  setExternalResource,
  setExternalUserJobs,
  setJobScoreReview,
  setProfileChangeRequestsList,
  setProfileNumber,
  setPropertyExternalResource,
  setResourcePositionList,
  setResourceStatusList,
  setsearchCriteria,
  setSingleExternalResource,
  setTreeMenueList,
  setUserPaymentData,
  setPropertyListDropdown,
} from "../../Slice/externalResourceSlice";
import { showSnackbar } from "../../Slice/snackbar/snackbarSlice";
import { setLoading } from "../../Slice/loading/loadingSlice";

export const getExternalResourceList = createAsyncThunk(
  "getExternalResourceList/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/getResources`,request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setExternalResource(response?.data));
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getSingleExternalResource = createAsyncThunk(
  "getSingleExternalResource",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/viewExternalget/${request.user_id}`);
      if (response?.status === 200) {
        dispatch(setSingleExternalResource(response?.data));
        dispatch(setLoading(false));
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getUserPaymentdata = createAsyncThunk(
  "getuserpaymentdata",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(
        `/getuserpaymentdata/${request?.user_id}`
      );
      if (response?.status === 200) {
        dispatch(setUserPaymentData(response?.data));
        dispatch(setLoading(false));
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getContactExternalResource = createAsyncThunk(
  "contactExternalget",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(
        `/contactExternalget/${request.user_id}`
      );
      if (response?.status === 200) {
        dispatch(setContactExternalResource(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getPropertyExternalResource = createAsyncThunk(
  "getUserProperty",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(
        `/getUserProperty/${request.user_id}/1`
      );
      if (response?.status === 200) {
        dispatch(setPropertyExternalResource(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const activationRemider = createAsyncThunk(
  "activationRemider",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/sendAcountActivationlink`, request);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "info",
          })
        );
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }
);

export const getProfileNumberExternal = createAsyncThunk(
  "getProfileNumber",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/userProfileNumber/${request}`);
      if (response?.status === 200) {
        dispatch(setProfileNumber(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getResourceStatusOptions = createAsyncThunk(
  "getResourceStatusOption",
  async (_, { dispatch }) => {
    try {
      const response = await authApi.get(`/userstatusactive`);
      if (response?.status === 200) {
        const options = response?.data?.map((item) => {
          return { value: item?.status_id, label: item?.status_name };
        });
        dispatch(setResourceStatusList(options));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }
);

// getTreeMenu
export const getTreeMenueOptions = createAsyncThunk(
  "getTreeMenueOptions",
  async (_, { dispatch }) => {
    try {
      const response = await authApi.get(`/getTreeMenu`);
      if (response?.status === 200) {
        const options = Object.values(response?.data).map((item) => ({
          value: item?.id,
          label: item?.name,
        }));

        dispatch(setTreeMenueList(options));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }
);

export const getResourcePosition = createAsyncThunk(
  "getResourcePosition",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/select2GetAll/${request?.id}`);
      if (response?.status === 200) {
        const options = response?.data?.data?.map((item) => {
          return { value: item?.position_id, label: item?.position_name };
        });
        dispatch(setResourcePositionList(options));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }
);

export const SaveUserProfileExternal = createAsyncThunk(
  "saveUserProfileExternal",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/saveUserProfileExternal`, request);
      if (response?.status === 200) {
        dispatch(saveNewExternalData(response?.data));
        dispatch(
          showSnackbar({
            message: response?.data?.msg || "Successfully Inserted",
            type: "success",
          })
        );
      }
      return response;
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);
export const UpdateUserProfileExternal = createAsyncThunk(
  "updateUserProfileExternal",
  async (request, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.put(
        `/updateUserProfileExternal/${request?.iUserId}`,
        request
      );
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg || "Successfully Inserted",
            type: "success",
          })
        );
        dispatch(setLoading(false));
        return response?.data;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
      return rejectWithValue(error?.response?.data || { msg: "Profile update failed." });
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getEditExternalResource = createAsyncThunk(
  "getProfile",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/getProfile/${request}`);

      if (response?.status === 200) {
        dispatch(setEditExternalResource(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Something went wrong.",
          type: "error",
        })
      );
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false)); // ✅ Called only once
    }
  }
);

export const getSearchedCriteria = createAsyncThunk(
  "searchByCreteria",
  async (request, { dispatch }) => {
    const { id, propertyId } = request;
    try {
      const response = await authApi.get(
        `/searchByCreteria/${propertyId}/${id}/1`
      );
      if (response?.status === 200) {
        dispatch(setsearchCriteria(response?.data));
      }
    } catch (error) {
      dispatch(setsearchCriteria([]));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);
export const getAllPropertiesValue = createAsyncThunk(
  "getAllPropertiesValue",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(
        `/getAllPropertiesValue`
      );
      if (response?.status === 200) {
        dispatch(setPropertyListDropdown(response?.data));
      }
    } catch (error) {
      dispatch(setPropertyListDropdown([]));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);

// ------------------ properties tab ---------------------
export const SaveUserProperty = createAsyncThunk(
  "userProperty",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/userProperty`, request);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg || "Successfully Inserted",
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);
export const deleteProperties = createAsyncThunk(
  "deleteUserProperty",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.delete(`/deleteUserProperty/${request}`);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);

// ------------------ payment tab ---------------------
export const getUserPaymentonEdit = createAsyncThunk(
  "getuserpayment/list",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/getuserpayment/${request}/1`);
      if (response?.status === 200) {
        dispatch(getUserPaymentData(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const savePayment = createAsyncThunk(
  "paymentsave",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/paymentsave`, request);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);
export const updatePayment = createAsyncThunk(
  "paymentsave/update",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(
        `/paymentsave/${request?.iUserId}/1`,
        request
      );
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);
export const CreateContactExternal = createAsyncThunk(
  "contactExternalsave/update",
  async (request, { dispatch }) => {
    const { iUserId, payload } = request;
    try {
      const response = await authApi.post(
        `/contactExternalsave/${iUserId}`,
        payload
      );
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);
export const updateExternalContact = createAsyncThunk(
  "contactExternalUpdate/update",
  async (request, { dispatch }) => {
    const { iUserId, payload } = request;
    try {
      const response = await authApi.post(
        `/contactExternalUpdate/${iUserId}`,
        payload
      );
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);
export const deleteContactExternal = createAsyncThunk(
  "deleteExternalContact/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.delete(
        `/deleteExternalContact/${request}`
      );
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);

export const resourceAssets = createAsyncThunk(
  "resourceAssets/list",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/resourceAssets/${request?.user_id}`);
      if (response?.status === 200) {
        dispatch(getResourceAssets(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getExternalUserJobs = createAsyncThunk(
  "getExternalUserJobs/list",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(
        `/getExternalUserJobs/${request?.user_id}`
      );
      if (response?.status === 200) {
        dispatch(setExternalUserJobs(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const createResourceAssets = createAsyncThunk(
  "resourceAssets/create",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/resourceAssets`, request);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const resourceAssetsByIuserId = createAsyncThunk(
  "resourceAssetsByIuserId",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/resourceAssetsByIuserId/${request}`);
      if (response?.status === 200) {
        dispatch(getResourceAssetsByIuserId(response?.data));
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getJobScoreReview = createAsyncThunk(
  "getJobScoreReview",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/getJobScoreReview`, request);
      if (response?.status === 200) {
        dispatch(setJobScoreReview(response?.data));
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const requestProfileChange = createAsyncThunk(
  "requestProfileChange",
  async (data, { dispatch }) => {
    try {
      const res = await authApi.post("/requestProfileChange", data);
      dispatch(
        showSnackbar({
          message: "Change request sent for approval",
          type: "success",
        })
      );
      return res.data;
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.response?.data?.msg || "Request failed",
          type: "error",
        })
      );
      throw e;
    }
  }
);
export const getUserProfileChangeRequests = createAsyncThunk(
  "externalResource/getUserProfileChangeRequests",
  async (request, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(
        "/listUserProfileChangeRequests",
        request // <-- POST BODY
      );

      if (response?.data?.status === 200) {
        dispatch(setProfileChangeRequestsList(response.data));
        return response.data;
      }

      return rejectWithValue(response?.data);
    } catch (error) {
      console.error("getUserProfileChangeRequests error:", error);
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const updateProfileChangeStatus = createAsyncThunk(
  "updateProfileChangeStatus",
  async ({ id, action }, { dispatch }) => {
    try {
      const res = await authApi.put(
        `/updateProfileChangeStatus/${id}`,
        { action }
      );

      dispatch(
        showSnackbar({
          message:
            action === "approved"
              ? "Profile change approved successfully"
              : "Profile change rejected successfully",
          type: "success",
        })
      );

      return res.data;
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.response?.data?.msg || "Action failed",
          type: "error",
        })
      );
      throw e;
    }
  }
);
